const fireTagEvent = async (eventName, eventData) => {
  if (window.dataLayer) {
    await window.dataLayer.push({ event: eventName, eventData: eventData });
  }
};

export const fireEvent = async function(event) {
  await fireTagEvent(event, {});
};
